import axios from 'axios';
import {BASE_URL_WEB} from '../../../utility/constants';
import {AxiosHelperPortal} from '../../../utility/helperFunctions';

export const updateWaiverSignedApi = async ({signed_name, publicWaiverKey}) => {
  const url = publicWaiverKey
    ? `${BASE_URL_WEB}verify-public-waiver?key=${publicWaiverKey}`
    : `${BASE_URL_WEB}verify-waiver??`;
  let response;
  try {
    response = publicWaiverKey
      ? await axios.post(url, {
          signed_name,
        })
      : await AxiosHelperPortal(url, 'post', {
          signed_name,
        });
    console.log('res', response);
    response = {status: response.status, data: response?.data};
  } catch (err) {
    console.log('error', err, err.response);
    response = {
      status: err.response.status,
      data: {message: err.response?.data?.message || 'Something went wrong!'},
    };
  }
  return response;
};

export const getPublicWaiverDetails = async key => {
  console.log('key', key);
  const url = `${BASE_URL_WEB}public-waiver?key=${key}`;
  let response;
  try {
    response = await axios.get(url);
    console.log('res', response);
    response = {status: response.status, data: response?.data};
  } catch (err) {
    console.log('error', err, err.response);
    response = {
      status: err.response.status,
      data: {message: err.response?.data?.message || 'Something went wrong!'},
    };
  }
  return response;
};

export const getPublicCompanyWaiverDetails = async companyId => {
  console.log('companyId', companyId);
  const url = `${BASE_URL_WEB}preview-company-waiver?companyId=${companyId}`;
  let response;
  try {
    response = await axios.get(url);
    console.log('res', response);
    response = {status: response.status, data: response?.data};
  } catch (err) {
    console.log('error', err, err.response);
    response = {
      status: err.response.status,
      data: {message: err.response?.data?.message || 'Something went wrong!'},
    };
  }
  return response;
};
